import Vue from "vue";
import VueRouter, {RouteConfig} from "vue-router";
import Login from "@/components/Login.vue";
import AuthService from "@/services/AuthService";
import UserListPage from "@/components/Admin/Users/UserListPage.vue";
import Welcome from "@/components/Welcome.vue";
import ClientDetailsPage from "@/components/Admin/Clients/Details/ClientDetailsPage.vue";
import ClientListPage from "@/components/Admin/Clients/List/ClientListPage.vue";
import TherapistListPage from "@/components/Admin/Therapists/List/TherapistListPage.vue";
import MedicineListPage from "@/components/Admin/Settings/Medicines/List/MedicineListPage.vue";
import TypeformSettingsPage from "@/components/Admin/Settings/Typeform/TypeformSettingsPage.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "Welcome",
        component: Welcome,
    },

    // Admin Area

    {
        path: "/users",
        name: "Users",
        component: UserListPage,
    },

    {
        path: "/clients",
        name: "Clients",
        component: ClientListPage,
    },
    {
        path: "/clients/:search",
        name: "ClientSearch",
        component: ClientListPage,
    },
    {
        path: "/clients/:clientId/dashboard/:tab",
        name: "Client",
        component: ClientDetailsPage,
    },

    {
        path: "/therapists",
        name: "Therapists",
        component: TherapistListPage,
    },

    {
        path: "/settings/medicines",
        name: "Medicines",
        component: MedicineListPage,
    },
    {
        path: "/settings/typeform",
        name: "Typeform",
        component: TypeformSettingsPage,
    },



    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            public: true,
            onlyWhenLoggedOut: true
        }
    }
];

const router = new VueRouter({
    mode: "history",
    // base: process.env.BASE_URL,
    base: "app",
    routes
});

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public);
    const onlyWhenLoggedOut = to.matched.some(
        record => record.meta.onlyWhenLoggedOut 
    );
    const loggedIn = AuthService.isLoggedIn();

    if (!isPublic && !loggedIn) {
        return next({
            path: "/login",
            query: {redirect: to.fullPath} // Store the full path to redirect the user to after login
        });
    }

    // Do not allow user to visit login page or register page if they are logged in
    if (loggedIn && onlyWhenLoggedOut) {
        return next("/");
    }

    // Set page title
    document.title = to.meta?.title || 'MedicaPro';

    next();
});

export default router;
